import React, { useState } from "react";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import Timer from "../Timer";
import ExamPanel from "../ExamPanel";

export default function WriteEssayMockPage({
  question,
  onInputChange,
  questionNumber,
  totalQuestions = 36,
}) {
  const [text, setText] = useState("");

  const handleTextChange = (newText) => {
    setText(newText);
    onInputChange(newText);
  };

  return (
    <ExamPanel
      eyebrow="Writing"
      title="Write Essay"
      questionLabel={`Question ${questionNumber} of ${totalQuestions}`}
      meta={
        <span className="inline-flex items-center gap-1">
          Time left: <Timer initialMinutes={20} initialSeconds={0} />
        </span>
      }
      instructions="You have 20 minutes to plan, write, and revise an essay about the topic below. Write 200-300 words."
    >
      <div className="space-y-5">
        <QuestionBox
          question={question?.question || ""}
          eyebrow="Essay topic"
          title="Plan and write your essay"
          scrollable={false}
        />

        <WriteBox
          onTextChange={handleTextChange}
          minHeight="min-h-[22rem]"
          title="Write 200-300 words"
          helper="Use paragraphs, supporting details, and a clear position."
          placeholder="Write your essay here..."
        />
      </div>
    </ExamPanel>
  );
}
